module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/common-module/components/split-container/split-container.component.scss
// module id = ./src/app/modules/common-module/components/split-container/split-container.component.scss
// module chunks = 9